/* eslint-disable */
import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  CbwDeviceDeleteResponse,
  CbwDeviceRegisterRequest,
  CbwDeviceRegisterResponse,
  CbwDeviceRegistrationStatusResponse,
  CbwDeviceRegistrationsResponse,
  CbwDeviceRelayLinkResponse,
  CbwDeviceRelayLinkCreateReq,
  CbwDeviceRelayLinkUpdateReq,
  CbwDeviceRelayLinksResponse,
  CbwDeviceRelayLink,
  CbwDeviceDetailResponse,
} from '../types/cbwDevice';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';

/**
 * CbwDeviceServiceApi - axios parameter creator
 * @export
 */
export const CbwDeviceServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Register CBW device
     * @summary Create and register CBW device
     * @param {CbwDeviceRegisterRequest} cbwDeviceRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceRegister: async (
      cbwDeviceRegisterRequest: CbwDeviceRegisterRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'cbwDeviceRegisterRequest' is not null or undefined
      assertParamExists(
        'cbwDeviceServiceRegister',
        'cbwDeviceRegisterRequest',
        cbwDeviceRegisterRequest
      );
      const localVarPath = `/cbw-devices/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cbwDeviceRegisterRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get CBW device registrations by organization
     * @summary Get CBW device registrations by organization
     * @param {string} [orgId] Organization ID
     * @param {number} [page] Page number
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRegistrations: async (
      orgId?: string,
      page?: number,
      limit?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/cbw-devices/registrations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get CBW device registration status
     * @summary Get CBW device registration status
     * @param {string} registrationId Registration ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRegistrationStatus: async (
      registrationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registrationId' is not null or undefined
      assertParamExists('cbwDeviceServiceGetRegistrationStatus', 'registrationId', registrationId);
      const localVarPath = `/cbw-devices/register/{registrationId}/status`.replace(
        `{${'registrationId'}}`,
        encodeURIComponent(String(registrationId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get CBW device details
     * @summary Get CBW device by ID
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGet: async (
      deviceId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceId' is not null or undefined
      assertParamExists('cbwDeviceServiceGet', 'deviceId', deviceId);
      const localVarPath = `/cbw-devices/{deviceId}`.replace(
        `{${'deviceId'}}`,
        encodeURIComponent(String(deviceId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete CBW device from cloud
     * @summary Delete CBW device from cloud
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceDelete: async (
      deviceId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceId' is not null or undefined
      assertParamExists('cbwDeviceServiceDelete', 'deviceId', deviceId);
      const localVarPath = `/cbw-devices/{deviceId}`.replace(
        `{${'deviceId'}}`,
        encodeURIComponent(String(deviceId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create CBW device relay link
     * @summary Bind intercom and CBW device
     * @param {string} deviceId CBW Device ID
     * @param {CbwDeviceRelayLinkCreateReq} cbwDeviceRelayLinkCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceCreateRelayLink: async (
      deviceId: string,
      cbwDeviceRelayLinkCreateReq: CbwDeviceRelayLinkCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceId' is not null or undefined
      assertParamExists('cbwDeviceServiceCreateRelayLink', 'deviceId', deviceId);
      // verify required parameter 'cbwDeviceRelayLinkCreateReq' is not null or undefined
      assertParamExists(
        'cbwDeviceServiceCreateRelayLink',
        'cbwDeviceRelayLinkCreateReq',
        cbwDeviceRelayLinkCreateReq
      );
      const localVarPath = `/cbw-devices/{deviceId}/relay-links`.replace(
        `{${'deviceId'}}`,
        encodeURIComponent(String(deviceId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cbwDeviceRelayLinkCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Manually sync all CBW devices
     * @summary Manually sync all CBW devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceSync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/cbw-devices/sync`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get CBW device relay links
     * @summary Get all relay links for a CBW device
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRelayLinks: async (
      deviceId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceId' is not null or undefined
      assertParamExists('cbwDeviceServiceGetRelayLinks', 'deviceId', deviceId);
      const localVarPath = `/cbw-devices/{deviceId}/relay-links`.replace(
        `{${'deviceId'}}`,
        encodeURIComponent(String(deviceId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update CBW device relay link
     * @summary Update intercom and CBW device link
     * @param {string} linkId Relay Link ID
     * @param {CbwDeviceRelayLinkUpdateReq} cbwDeviceRelayLinkUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceUpdateRelayLink: async (
      linkId: string,
      cbwDeviceRelayLinkUpdateReq: CbwDeviceRelayLinkUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('cbwDeviceServiceUpdateRelayLink', 'linkId', linkId);
      // verify required parameter 'cbwDeviceRelayLinkUpdateReq' is not null or undefined
      assertParamExists(
        'cbwDeviceServiceUpdateRelayLink',
        'cbwDeviceRelayLinkUpdateReq',
        cbwDeviceRelayLinkUpdateReq
      );
      const localVarPath = `/cbw-devices/relay-links/{linkId}`.replace(
        `{${'linkId'}}`,
        encodeURIComponent(String(linkId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cbwDeviceRelayLinkUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CbwDeviceServiceApi - functional programming interface
 * @export
 */
export const CbwDeviceServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CbwDeviceServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * Register CBW device
     * @summary Create and register CBW device
     * @param {CbwDeviceRegisterRequest} cbwDeviceRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceRegister(
      cbwDeviceRegisterRequest: CbwDeviceRegisterRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceRegisterResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceRegister(
        cbwDeviceRegisterRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceRegister']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get CBW device registrations by organization
     * @summary Get CBW device registrations by organization
     * @param {string} [orgId] Organization ID
     * @param {number} [page] Page number
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceGetRegistrations(
      orgId?: string,
      page?: number,
      limit?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceRegistrationsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceGetRegistrations(
        orgId,
        page,
        limit,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceGetRegistrations']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get CBW device registration status
     * @summary Get CBW device registration status
     * @param {string} registrationId Registration ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceGetRegistrationStatus(
      registrationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CbwDeviceRegistrationStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cbwDeviceServiceGetRegistrationStatus(
          registrationId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceGetRegistrationStatus']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get CBW device details
     * @summary Get CBW device by ID
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceGet(
      deviceId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceDetailResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceGet(
        deviceId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Delete CBW device from cloud
     * @summary Delete CBW device from cloud
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceDelete(
      deviceId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceDeleteResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceDelete(
        deviceId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create CBW device relay link
     * @summary Bind intercom and CBW device
     * @param {string} deviceId CBW Device ID
     * @param {CbwDeviceRelayLinkCreateReq} cbwDeviceRelayLinkCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceCreateRelayLink(
      deviceId: string,
      cbwDeviceRelayLinkCreateReq: CbwDeviceRelayLinkCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceRelayLinkResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceCreateRelayLink(
        deviceId,
        cbwDeviceRelayLinkCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceCreateRelayLink']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Manually sync all CBW devices
     * @summary Manually sync all CBW devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceSync(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceSyncResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceSync(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceSync']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get CBW device relay links
     * @summary Get all relay links for a CBW device
     * @param {string} deviceId CBW Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceGetRelayLinks(
      deviceId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceRelayLinksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceGetRelayLinks(
        deviceId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceGetRelayLinks']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Update CBW device relay link
     * @summary Update intercom and CBW device link
     * @param {string} linkId Relay Link ID
     * @param {CbwDeviceRelayLinkUpdateReq} cbwDeviceRelayLinkUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cbwDeviceServiceUpdateRelayLink(
      linkId: string,
      cbwDeviceRelayLinkUpdateReq: CbwDeviceRelayLinkUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbwDeviceRelayLinkResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cbwDeviceServiceUpdateRelayLink(
        linkId,
        cbwDeviceRelayLinkUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CbwDeviceServiceApi.cbwDeviceServiceUpdateRelayLink']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CbwDeviceServiceApi - factory interface
 * @export
 */
export const CbwDeviceServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CbwDeviceServiceApiFp(configuration);
  return {
    /**
     * Register CBW device
     * @summary Create and register CBW device
     * @param {CbwDeviceServiceApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceRegister(
      requestParameters: CbwDeviceServiceApiRegisterRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRegisterResponse> {
      return localVarFp
        .cbwDeviceServiceRegister(requestParameters.cbwDeviceRegisterRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Get CBW device registrations by organization
     * @summary Get CBW device registrations by organization
     * @param {CbwDeviceServiceApiGetRegistrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRegistrations(
      requestParameters: CbwDeviceServiceApiGetRegistrationsRequest = {},
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRegistrationsResponse> {
      return localVarFp
        .cbwDeviceServiceGetRegistrations(
          requestParameters.orgId,
          requestParameters.page,
          requestParameters.limit,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Get CBW device registration status
     * @summary Get CBW device registration status
     * @param {CbwDeviceServiceApiGetRegistrationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRegistrationStatus(
      requestParameters: CbwDeviceServiceApiGetRegistrationStatusRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRegistrationStatusResponse> {
      return localVarFp
        .cbwDeviceServiceGetRegistrationStatus(requestParameters.registrationId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Get CBW device details
     * @summary Get CBW device by ID
     * @param {CbwDeviceServiceApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGet(
      requestParameters: CbwDeviceServiceApiGetRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceDetailResponse> {
      return localVarFp
        .cbwDeviceServiceGet(requestParameters.deviceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Delete CBW device from cloud
     * @summary Delete CBW device from cloud
     * @param {CbwDeviceServiceApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceDelete(
      requestParameters: CbwDeviceServiceApiDeleteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceDeleteResponse> {
      return localVarFp
        .cbwDeviceServiceDelete(requestParameters.deviceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Create CBW device relay link
     * @summary Bind intercom and CBW device
     * @param {CbwDeviceServiceApiCreateRelayLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceCreateRelayLink(
      requestParameters: CbwDeviceServiceApiCreateRelayLinkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRelayLinkResponse> {
      return localVarFp
        .cbwDeviceServiceCreateRelayLink(
          requestParameters.deviceId,
          requestParameters.cbwDeviceRelayLinkCreateReq,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Manually sync all CBW devices
     * @summary Manually sync all CBW devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceSync(options?: RawAxiosRequestConfig): AxiosPromise<CbwDeviceSyncResponse> {
      return localVarFp.cbwDeviceServiceSync(options).then(request => request(axios, basePath));
    },
    /**
     * Get CBW device relay links
     * @summary Get all relay links for a CBW device
     * @param {CbwDeviceServiceApiGetRelayLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceGetRelayLinks(
      requestParameters: CbwDeviceServiceApiGetRelayLinksRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRelayLinksResponse> {
      return localVarFp
        .cbwDeviceServiceGetRelayLinks(requestParameters.deviceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Update CBW device relay link
     * @summary Update intercom and CBW device link
     * @param {CbwDeviceServiceApiUpdateRelayLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cbwDeviceServiceUpdateRelayLink(
      requestParameters: CbwDeviceServiceApiUpdateRelayLinkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CbwDeviceRelayLinkResponse> {
      return localVarFp
        .cbwDeviceServiceUpdateRelayLink(
          requestParameters.linkId,
          requestParameters.cbwDeviceRelayLinkUpdateReq,
          options
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for cbwDeviceServiceRegister operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiRegisterRequest
 */
export interface CbwDeviceServiceApiRegisterRequest {
  /**
   *
   * @type {CbwDeviceRegisterRequest}
   * @memberof CbwDeviceServiceApiRegister
   */
  readonly cbwDeviceRegisterRequest: CbwDeviceRegisterRequest;
}

/**
 * Request parameters for cbwDeviceServiceGetRegistrations operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiGetRegistrationsRequest
 */
export interface CbwDeviceServiceApiGetRegistrationsRequest {
  /**
   * Organization ID
   * @type {string}
   * @memberof CbwDeviceServiceApiGetRegistrations
   */
  readonly orgId?: string;

  /**
   * Page number
   * @type {number}
   * @memberof CbwDeviceServiceApiGetRegistrations
   */
  readonly page?: number;

  /**
   * Number of items per page
   * @type {number}
   * @memberof CbwDeviceServiceApiGetRegistrations
   */
  readonly limit?: number;
}

/**
 * Request parameters for cbwDeviceServiceGetRegistrationStatus operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiGetRegistrationStatusRequest
 */
export interface CbwDeviceServiceApiGetRegistrationStatusRequest {
  /**
   * Registration ID
   * @type {string}
   * @memberof CbwDeviceServiceApiGetRegistrationStatus
   */
  readonly registrationId: string;
}

/**
 * Request parameters for cbwDeviceServiceGet operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiGetRequest
 */
export interface CbwDeviceServiceApiGetRequest {
  /**
   * CBW Device ID
   * @type {string}
   * @memberof CbwDeviceServiceApiGet
   */
  readonly deviceId: string;
}

/**
 * Request parameters for cbwDeviceServiceDelete operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiDeleteRequest
 */
export interface CbwDeviceServiceApiDeleteRequest {
  /**
   * CBW Device ID
   * @type {string}
   * @memberof CbwDeviceServiceApiDelete
   */
  readonly deviceId: string;
}

/**
 * Request parameters for cbwDeviceServiceCreateRelayLink operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiCreateRelayLinkRequest
 */
export interface CbwDeviceServiceApiCreateRelayLinkRequest {
  /**
   * CBW Device ID
   * @type {string}
   * @memberof CbwDeviceServiceApiCreateRelayLink
   */
  readonly deviceId: string;

  /**
   *
   * @type {CbwDeviceRelayLinkCreateReq}
   * @memberof CbwDeviceServiceApiCreateRelayLink
   */
  readonly cbwDeviceRelayLinkCreateReq: CbwDeviceRelayLinkCreateReq;
}

/**
 * CBW Device Sync Response
 * @export
 * @interface CbwDeviceSyncResponse
 */
export interface CbwDeviceSyncResponse {
  /**
   * Success status
   * @type {boolean}
   * @memberof CbwDeviceSyncResponse
   */
  success: boolean;
  /**
   * Sync response data
   * @type {CbwDeviceSyncData}
   * @memberof CbwDeviceSyncResponse
   */
  data: CbwDeviceSyncData;
}

/**
 * CBW Device Sync Data
 * @export
 * @interface CbwDeviceSyncData
 */
export interface CbwDeviceSyncData {
  /**
   * Registration sync results
   * @type {CbwDeviceSyncRegistrations}
   * @memberof CbwDeviceSyncData
   */
  registrations: CbwDeviceSyncRegistrations;
  /**
   * Device status sync results
   * @type {Array<CbwDeviceSyncStatus>}
   * @memberof CbwDeviceSyncData
   */
  deviceStatus: Array<CbwDeviceSyncStatus>;
  /**
   * Cleanup results
   * @type {CbwDeviceSyncCleanup}
   * @memberof CbwDeviceSyncData
   */
  cleanup: CbwDeviceSyncCleanup;
  /**
   * Sync timestamp
   * @type {string}
   * @memberof CbwDeviceSyncData
   */
  timestamp: string;
}

/**
 * CBW Device Sync Registrations
 * @export
 * @interface CbwDeviceSyncRegistrations
 */
export interface CbwDeviceSyncRegistrations {
  /**
   * Sync message
   * @type {string}
   * @memberof CbwDeviceSyncRegistrations
   */
  message: string;
}

/**
 * CBW Device Sync Status
 * @export
 * @interface CbwDeviceSyncStatus
 */
export interface CbwDeviceSyncStatus {
  /**
   * Device ID
   * @type {string}
   * @memberof CbwDeviceSyncStatus
   */
  deviceId: string;
  /**
   * CBW Device ID
   * @type {string}
   * @memberof CbwDeviceSyncStatus
   */
  cbwDeviceId: string;
  /**
   * Serial number
   * @type {string}
   * @memberof CbwDeviceSyncStatus
   */
  serialNumber: string;
  /**
   * Device name
   * @type {string}
   * @memberof CbwDeviceSyncStatus
   */
  deviceName: string;
  /**
   * Sync status
   * @type {string}
   * @memberof CbwDeviceSyncStatus
   */
  status: string;
  /**
   * Online status
   * @type {boolean}
   * @memberof CbwDeviceSyncStatus
   */
  online: boolean;
}

/**
 * CBW Device Sync Cleanup
 * @export
 * @interface CbwDeviceSyncCleanup
 */
export interface CbwDeviceSyncCleanup {
  /**
   * Cleanup message
   * @type {string}
   * @memberof CbwDeviceSyncCleanup
   */
  message: string;
}

/**
 * Request parameters for cbwDeviceServiceGetRelayLinks operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiGetRelayLinksRequest
 */
export interface CbwDeviceServiceApiGetRelayLinksRequest {
  /**
   * CBW Device ID
   * @type {string}
   * @memberof CbwDeviceServiceApiGetRelayLinks
   */
  readonly deviceId: string;
}

/**
 * Request parameters for cbwDeviceServiceUpdateRelayLink operation in CbwDeviceServiceApi.
 * @export
 * @interface CbwDeviceServiceApiUpdateRelayLinkRequest
 */
export interface CbwDeviceServiceApiUpdateRelayLinkRequest {
  /**
   * Relay Link ID
   * @type {string}
   * @memberof CbwDeviceServiceApiUpdateRelayLink
   */
  readonly linkId: string;

  /**
   *
   * @type {CbwDeviceRelayLinkUpdateReq}
   * @memberof CbwDeviceServiceApiUpdateRelayLink
   */
  readonly cbwDeviceRelayLinkUpdateReq: CbwDeviceRelayLinkUpdateReq;
}

/**
 * CbwDeviceServiceApi - object-oriented interface
 * @export
 * @class CbwDeviceServiceApi
 * @extends {BaseAPI}
 */
export class CbwDeviceServiceApi extends BaseAPI {
  /**
   * Register CBW device
   * @summary Create and register CBW device
   * @param {CbwDeviceServiceApiRegisterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceRegister(
    requestParameters: CbwDeviceServiceApiRegisterRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceRegister(requestParameters.cbwDeviceRegisterRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get CBW device registrations by organization
   * @summary Get CBW device registrations by organization
   * @param {CbwDeviceServiceApiGetRegistrationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceGetRegistrations(
    requestParameters: CbwDeviceServiceApiGetRegistrationsRequest = {},
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceGetRegistrations(
        requestParameters.orgId,
        requestParameters.page,
        requestParameters.limit,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get CBW device registration status
   * @summary Get CBW device registration status
   * @param {CbwDeviceServiceApiGetRegistrationStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceGetRegistrationStatus(
    requestParameters: CbwDeviceServiceApiGetRegistrationStatusRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceGetRegistrationStatus(requestParameters.registrationId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get CBW device details
   * @summary Get CBW device by ID
   * @param {CbwDeviceServiceApiGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceGet(
    requestParameters: CbwDeviceServiceApiGetRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceGet(requestParameters.deviceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Delete CBW device from cloud
   * @summary Delete CBW device from cloud
   * @param {CbwDeviceServiceApiDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceDelete(
    requestParameters: CbwDeviceServiceApiDeleteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceDelete(requestParameters.deviceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Create CBW device relay link
   * @summary Bind intercom and CBW device
   * @param {CbwDeviceServiceApiCreateRelayLinkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceCreateRelayLink(
    requestParameters: CbwDeviceServiceApiCreateRelayLinkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceCreateRelayLink(
        requestParameters.deviceId,
        requestParameters.cbwDeviceRelayLinkCreateReq,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Manually sync all CBW devices
   * @summary Manually sync all CBW devices
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceSync(options?: RawAxiosRequestConfig) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceSync(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get CBW device relay links
   * @summary Get all relay links for a CBW device
   * @param {CbwDeviceServiceApiGetRelayLinksRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceGetRelayLinks(
    requestParameters: CbwDeviceServiceApiGetRelayLinksRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceGetRelayLinks(requestParameters.deviceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Update CBW device relay link
   * @summary Update intercom and CBW device link
   * @param {CbwDeviceServiceApiUpdateRelayLinkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbwDeviceServiceApi
   */
  public cbwDeviceServiceUpdateRelayLink(
    requestParameters: CbwDeviceServiceApiUpdateRelayLinkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CbwDeviceServiceApiFp(this.configuration)
      .cbwDeviceServiceUpdateRelayLink(
        requestParameters.linkId,
        requestParameters.cbwDeviceRelayLinkUpdateReq,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }
}
